import React, { useState } from "react";
import { Layout, Stack } from '@shopify/polaris';

import AdminPage from "../../components/AdminPage";
import AppPage from "../../components/AppPage";
import HistoryFilter from '../../components/HistoryFilter';
import { DateRange } from '../Dashboard/useDateRange'
import StandaloneCartDashboard from './StandaloneCartDashboard';

const defaultFilter = {
      hostId: null,
      range: DateRange.last30,
}

const StandaloneCartDashboardPage = () => {
      const [filter, setFilter] = useState(defaultFilter);

      const onRefresh = () => {
            setFilter({...filter});
      }

      return (
            <AppPage title={<>Standalone Cart Dashboard</>}>
                  <Layout>
                        <Layout.Section>
                              <Stack distribution='trailing'>
                                    <HistoryFilter
                                          onChangeFilter={setFilter}
                                          onRefresh={onRefresh}
                                          onExport={null}
                                          isExportInProgress={false}
                                          defaultFilter={defaultFilter}
                                          hideSearch
                                          hideEventTypes
                                    />
                              </Stack>
                        </Layout.Section>

                        <Layout.Section>
                              <StandaloneCartDashboard filter={filter} />
                        </Layout.Section>
                  </Layout>
            </AppPage>
      )
};

export default function () {
      return (
            <AdminPage>
                  <StandaloneCartDashboardPage />
            </AdminPage>
      )
}
